import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { Box } from '@mui/material';
import AppBar from './AppBar';
import CategoryNav, { categorySeparators } from './CategoryNav';
const TopBar = ({ rootCategory, title, showLogo, showSearch, showMyLearningsBtn, showMyMeetings, showProfileBtn, limitToPageWidth, searchAction, stickyAppBar, stickyCategoryNav, editData, showSubCategoryDropdowns, showCustomBtn, link, label, settings, useLabelsForSignInMyAccount, }) => {
    const appBarComponent = (_jsx(AppBar, { rootCategory: rootCategory, title: title, showLogo: showLogo, showSearch: showSearch, showMyLearningsBtn: showMyLearningsBtn, showMyMeetings: showMyMeetings, showProfileBtn: showProfileBtn, limitToPageWidth: limitToPageWidth, searchAction: searchAction, sticky: false, editData: editData, showSubCategoryDropdowns: showSubCategoryDropdowns, showCustomBtn: showCustomBtn, link: link, label: label, useLabelsForSignInMyAccount: useLabelsForSignInMyAccount }));
    const categoryNavComponent = (_jsx(CategoryNav, { rootCategory: rootCategory, limitToPageWidth: limitToPageWidth, showSubCategoryDropdowns: showSubCategoryDropdowns, editData: editData, settings: settings, sticky: false }));
    if (stickyAppBar && stickyCategoryNav) {
        return (_jsxs(Box, { sx: { position: 'sticky', top: 0, zIndex: 1100 }, children: [appBarComponent, categoryNavComponent] }));
    }
    return (_jsxs(_Fragment, { children: [_jsx(Box, { sx: { position: stickyAppBar ? 'sticky' : 'relative', top: 0, zIndex: stickyAppBar ? 1100 : 'auto' }, children: appBarComponent }), _jsx(Box, { sx: { position: stickyCategoryNav ? 'sticky' : 'relative', top: 0, zIndex: stickyCategoryNav ? 1099 : 'auto' }, children: categoryNavComponent })] }));
};
/** Preload the logo */
TopBar.getData = async (props, store) => {
    await AppBar.getData(props, store);
    // await CategoryNav.getData(props, store);
    return 'ok';
};
TopBar.defaultProps = {
    showLogo: true,
    showSearch: true,
    showMyLearningsBtn: true,
    showMyMeetings: false,
    showCustomBtn: false,
    showProfileBtn: true,
    stickyAppBar: false,
    stickyCategoryNav: false,
    useLabelsForSignInMyAccount: false,
    settings: {
        defaultSeparatorValue: categorySeparators.verticalBar.value,
    },
};
TopBar.meta = {
    group: 'portal',
    name: 'Top Bar',
    description: 'Combines AppBar and CategoryNav components',
    props: [
        {
            key: 'showLogo',
            name: 'Show Logo',
            type: 'boolean',
            description: 'Show the logo on app header',
        },
        {
            key: 'showSearch',
            name: 'Show Search',
            type: 'boolean',
            description: 'Show the search container on app header',
        },
        {
            key: 'searchAction',
            name: 'Search Action',
            type: 'function',
            description: 'Action to take when user performs a search.',
        },
        {
            key: 'title',
            name: 'Title',
            type: 'text',
            description: 'Title to be displayed in the AppBar.',
        },
        {
            key: 'showMyLearningsBtn',
            name: 'Show My Learnings Button',
            type: 'boolean',
            description: 'Show my learnings button on app header',
        },
        {
            key: 'showMyMeetings',
            name: 'Show My Meetings Button',
            type: 'boolean',
            description: 'Show My Meetings button on app header',
        },
        {
            key: 'showCustomBtn',
            name: 'Show Custom Button',
            type: 'boolean',
            description: 'Show custom button on app header',
        },
        {
            key: 'label',
            name: 'Custom Button Label',
            type: 'text',
            description: 'Custom button label.',
        },
        {
            key: 'link',
            name: 'Custom Button Click Action',
            type: 'link',
            description: 'Link to go to when button clicked.',
        },
        {
            key: 'showProfileBtn',
            name: 'Show Profile Button',
            type: 'boolean',
            description: 'Show the loggedIn profile details button on app header.',
        },
        {
            key: 'limitToPageWidth',
            name: 'Limit Width',
            type: 'boolean',
            description: 'Limit the width of the stack to the maximum page width',
        },
        {
            key: 'rootCategory',
            name: 'Root Category',
            type: 'category',
            description: 'Category that holds the top level categories beneath it.',
        },
        {
            key: 'showSubCategoryDropdowns',
            name: 'Show SubCategory Dropdowns',
            type: 'boolean',
            description: 'Instead of linking to the category, show the menu of SubCategories.',
        },
        {
            key: 'settings.defaultSeparatorValue',
            name: 'Category separator',
            type: 'array',
            items: categorySeparators,
            description: 'Seperator icon that appears between Top-Level Category',
        },
        {
            key: 'stickyAppBar',
            name: 'Sticky To Top AppBar',
            type: 'boolean',
            description: 'Keep the app bar at the top of the page when scrolling',
        },
        {
            key: 'stickyCategoryNav',
            name: 'Sticky To Top Category Navigation',
            type: 'boolean',
            description: 'Keep the category navigation at the top of the page when scrolling',
        },
        {
            key: 'useLabelsForSignInMyAccount',
            name: 'Use Labels for Sign-in/My Account',
            type: 'boolean',
            description: 'Use labels instead of the profile button for sign-in and my account actions.',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'TopBar',
        props: {
            showLogo: true,
            label: 'Button',
            link: {
                type: 'none',
            },
            showSearch: true,
            showMyLeanringsBtn: true,
            showCustomBtn: false,
            showProfileBtn: true,
            stickyAppBar: false,
            stickyCategoryNav: false,
            limitToPageWidth: true,
            searchAction: '@searchAction',
            rootCategory: '@rootCategory',
            useLabelsForSignInMyAccount: false,
            settings: {
                defaultSeparatorValue: categorySeparators.verticalBar.value,
                limitToPageWidth: true,
            },
        },
    },
};
export default observer(TopBar);
//# sourceMappingURL=TopBar.js.map